// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"Dca-z"};